import React from 'react';

export default function Menu() {
    return (
        <nav id="navbar-menu" className="navbar navbar-default navbar-header-full" role="navigation">
            <div className="menu sticky">
                <div className="container-fluid">
                    <div className="navbar-header">
                        <button type="button" className="navbar-toggle btnMenu" data-toggle="collapse" data-target=".navbar-collapse">
                            <span className="sr-only"></span>
                            <i className="fa fa-bars"></i>
                        </button>
                        <a className="navbar-brand" href="/">&nbsp;</a>
                        <div className="header-full-title hidden-xs hidden-sm hidden-md">Centro Espírita<span> Evangelho e Amor</span><p>Integrada à Aliança Espírita Evangélica</p></div>
                    </div>
                    <div className="collapse navbar-collapse itensMemu">
                        <ul className="nav navbar-nav navbar-right padding-right-150">
                            <li className="active"><a href="#convite" className="itemMenu">Convite</a></li>
                            <li><a href="#sobre" className="itemMenu">Sobre</a></li>
                            <li><a href="#depoimentos" className="itemMenu">Depoimentos</a></li>
                            <li><a href="#inscricao" className="itemMenu">Inscrição</a></li>
                            <li><a href="#contato" className="itemMenu">Contato</a></li>
                            <li><a href="https://www.evangelhoeamor.com.br/" target="_blank" rel="noopener noreferrer" className="itemMenu">CEEA</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </nav>
    );
}